// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-container {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 600px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  
  .modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-header h2 {
    font-size: 18px;
    font-weight: 500;
    color: #111827;
    margin: 0;
  }
  
  .close-button {
    background: none;
    border: none;
    color: #6b7280;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }
  
  .close-button:hover {
    background-color: #f3f4f6;
  }
  
  .modal-content {
    padding: 24px;
  }
  
  .select-text {
    font-size: 14px;
    color: #374151;
    margin-bottom: 16px;
  }
  
  .required {
    color: #ef4444;
    margin-left: 2px;
  }
  
  .letter-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .letter-option {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .letter-option.selected {
    border-color: #0d9488;
    background-color: #f0fdfa;
  }
  
  .radio-container {
    position: relative;
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  .radio-circle {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: white;
    border: 2px solid #d1d5db;
    border-radius: 50%;
  }
  
  .letter-option.selected .radio-circle {
    border-color: #0d9488;
  }
  
  .letter-option.selected .radio-circle:after {
    content: "";
    position: absolute;
    top: 4px;
    left: 4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #0d9488;
  }
  
  .option-content {
    flex: 1 1;
  }
  
  .option-content h3 {
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    margin: 0 0 4px 0;
  }
  
  .option-content p {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }
  
  .modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  
  .cancel-button {
    padding: 8px 16px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    color: #374151;
    font-size: 14px;
    cursor: pointer;
  }
  
  .cancel-button:hover {
    background-color: #f9fafb;
  }
  
  .generate-button {
    padding: 8px 16px;
    background: #0d9488;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }
  
  .generate-button:hover {
    background-color: #0f766e;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/GenerateLetterModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iFAAiF;EACnF;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modal-container {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 600px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  \n  .modal-header {\n    padding: 20px 24px;\n    border-bottom: 1px solid #e5e7eb;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .modal-header h2 {\n    font-size: 18px;\n    font-weight: 500;\n    color: #111827;\n    margin: 0;\n  }\n  \n  .close-button {\n    background: none;\n    border: none;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n  }\n  \n  .close-button:hover {\n    background-color: #f3f4f6;\n  }\n  \n  .modal-content {\n    padding: 24px;\n  }\n  \n  .select-text {\n    font-size: 14px;\n    color: #374151;\n    margin-bottom: 16px;\n  }\n  \n  .required {\n    color: #ef4444;\n    margin-left: 2px;\n  }\n  \n  .letter-options {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .letter-option {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 16px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .letter-option.selected {\n    border-color: #0d9488;\n    background-color: #f0fdfa;\n  }\n  \n  .radio-container {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    margin-top: 2px;\n  }\n  \n  .radio-container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  \n  .radio-circle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 2px solid #d1d5db;\n    border-radius: 50%;\n  }\n  \n  .letter-option.selected .radio-circle {\n    border-color: #0d9488;\n  }\n  \n  .letter-option.selected .radio-circle:after {\n    content: \"\";\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #0d9488;\n  }\n  \n  .option-content {\n    flex: 1;\n  }\n  \n  .option-content h3 {\n    font-size: 14px;\n    font-weight: 500;\n    color: #111827;\n    margin: 0 0 4px 0;\n  }\n  \n  .option-content p {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 0;\n  }\n  \n  .modal-footer {\n    padding: 16px 24px;\n    border-top: 1px solid #e5e7eb;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n  }\n  \n  .cancel-button {\n    padding: 8px 16px;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    color: #374151;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  \n  .cancel-button:hover {\n    background-color: #f9fafb;\n  }\n  \n  .generate-button {\n    padding: 8px 16px;\n    background: #0d9488;\n    border: none;\n    border-radius: 6px;\n    color: white;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  \n  .generate-button:hover {\n    background-color: #0f766e;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
